import { render, staticRenderFns } from "./deliveryModify.vue?vue&type=template&id=c0d1122a&"
import script from "./deliveryModify.js?vue&type=script&lang=js&"
export * from "./deliveryModify.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0d1122a')) {
      api.createRecord('c0d1122a', component.options)
    } else {
      api.reload('c0d1122a', component.options)
    }
    module.hot.accept("./deliveryModify.vue?vue&type=template&id=c0d1122a&", function () {
      api.rerender('c0d1122a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDialog/deliveryModify/deliveryModify.vue"
export default component.exports